import Api from './Api'
import { getItem } from '../utils/localstorage'

const getMethod = async (route, extraConfig) => {
  const authToken = getItem('token')
  if (!authToken) return {}
  try {
    return await Api.get(route, extraConfig)
  } catch (error) {
    return error
  }
}
const postMethod = async (route, payload, headers) => {
  try {
    return await Api.post(route, payload, headers)
  } catch (error) {
    return error
  }
}
const patchMethod = async (route, payload) => {
  try {
    return await Api.patch(route, payload)
  } catch (error) {
    return error
  }
}
const deleteMethod = async (route, payload) => {
  try {
    return await Api.delete(route, payload)
  } catch (error) {
    return error
  }
}
const putMethod = async (route, payload, config) => {
  try {
    return await Api.put(route, payload, config)
  } catch (error) {
    return error
  }
}

export { deleteMethod, getMethod, patchMethod, postMethod, putMethod }
